import { Languages } from 'modules/core/enums/languages';
import { ContactProperty } from './contactProperty';

export class AccountData {
  public name: string;
  public phone: string;
  public email: string;
  public lang: Languages;
  public domain?: string;
  public props: ContactProperty[];
  public password: string;

  public constructor(data?: any) {
    this.name = (data && data.name) ? data.name : undefined;
    this.phone = (data && data.phone) ? data.phone : undefined;
    this.email = (data && data.email) ? data.email : undefined;
    this.lang = (data && data.lang) ? data.lang : Languages.PL;
    this.domain = (data && data.domain) ? data.domain : undefined;
    this.props = (data && data.props) ? ContactProperty.ofCollection(data.props) : [];
    this.password = (data && data.password) ? data.password : '';
  }
}
